<template>
  <div class="container">

    <b-modal
      v-model="publishConfirmationModal"
      content-class="airspirit-modal"
      hide-footer
      header-class="airspirit-modal-header"
      size="md"
    >
      <template #modal-header>
        <div 
          @click="closePublishModal"
          class="airspirit-modal-header--close-icon"
          style="float: left"
        >
          <img 
            :src="require('@/assets/images/pictos/croix.svg')"
          />
        </div>
        <div
          class="airspirit-modal-header--title"
          style=""
        >
          {{ $t('learn_new_video.content_submitted') }}
        </div>
      </template>
      <p>
        {{ $t('learn_new_video.content_submitted_message') }}
      </p>
      <button
        class="profile-validation-button"
        style="width: 100%;"
        @click="closePublishModal"
      >
        {{ $t('learn_new_video.ok') }}
      </button>
    </b-modal>

    <ProfileTitleComponent
      :title="$t('learn_new_video.title')"
      :subtitle="$t('learn_new_video.subtitle')"
    />

    <create-or-modify-video
      :categories="categories"
      :create="true"
      @create-or-modify-video="createVideo"
    />

  </div>
</template>

<script>
import { APIUserConnected } from '@/api/APIUserConnected'
import ProfileTitleComponent from '@/components/user/profile/ProfileTitleComponent'
import CreateOrModifyVideo from '@/components/video/CreateOrModifyVideo.vue'

const apiUserConnected = new APIUserConnected()

export default {
  name: 'LearnNewVideo',
  components: {
    ProfileTitleComponent,
    CreateOrModifyVideo,
  },
  data() {
    return {
      categories: [
        this.$t('learn_new_video.categories.recreational_pilot'),
        this.$t('learn_new_video.categories.professional_pilot'),
        this.$t('learn_new_video.categories.commercial_crew'),
        this.$t('learn_new_video.categories.aircraft_mechanic'),
        this.$t('learn_new_video.categories.drone_operator'),
        this.$t('learn_new_video.categories.engineering'),
        this.$t('learn_new_video.categories.traffic_controller'),
      ],
      publishConfirmationModal: false,
    }
  },
  computed: {
    token () {
      return this.$store.state.auth.token
    }
  },
  
  methods: {
    async createVideo(video) {
      this.$store.commit('loadFromAPI')
      const formData = new FormData()
      formData.append('categories', JSON.stringify(video.categories))
      formData.append('title', video.title)
      formData.append('description', video.description)
      formData.append('file', video.file)
      formData.append('image_cover', video.image_cover)
      formData.append('video_access_option', video.video_access_option)
      formData.append('status', video.status)
      if (video.price !== null && video.price !== undefined && video.price !== '') {
        formData.append('price', video.price)
      }
      await apiUserConnected.createVideo(formData)
      this.$store.commit('endLoadingFromAPI')
      
      // Show modal for VALIDATED, toast for DRAFT
      if (video.status === 'VALIDATED') {
        this.publishConfirmationModal = true
      } else {
        this.$root.$bvToast.toast(this.$t('learn_new_video.saved_as_draft_message'), {
          title: this.$t('learn_new_video.saved_as_draft_title'),
          autoHideDelay: 5000,
          appendToast: false,
          variant: "success"
        })
        this.$router.push('/user/account/content')
      }
    },
    closePublishModal() {
      this.publishConfirmationModal = false
      this.$router.push('/user/account/content')
    }
  },
}
</script>

